import { Intensity, Setting } from '@cssat/acorn-service-delivery';
import { enumToDisplay } from '../lib/string';

export const presentIntensity = (intensity: Intensity) =>
  enumToDisplay(intensity);
export const presentSetting = (setting: Setting) => {
  let suffix = '';
  switch (setting) {
    case Setting.Correspondence:
      suffix = ' (email/letter)';
  }

  return `${enumToDisplay(setting)} ${suffix}`;
};
